import { all, put, call, takeEvery, takeLatest } from 'redux-saga/effects';

import { agentActions } from '$store/agent/index';
import { Api } from '$api';
import { batchActions } from '$store';
import { mainActions } from '$store/main';
import { appActions } from '$store/app/index';
import { InstallAppAction, LoadAppAction } from '$store/app/interface';
import { toastActions } from '$store/toast';

function* loadAppWorker(action: LoadAppAction) {
  try {
    const { appId } = action.payload;
    const data = yield call(Api.get, `/app/${appId}`);
    yield put(batchActions(appActions.setApp(data)));
  } catch (e) {
    yield put(appActions.setFailed());
  }
}

function* installAppWorker(action: InstallAppAction) {
  try {
    yield put(toastActions.setToastLoading());
    yield call(Api.post, `/app/${action.payload}/install`);
    yield put(batchActions(appActions.setAppInstalled(), toastActions.hideToast()));
  } catch (e) {
    yield put(toastActions.setToastFail(e.message));
  }
}

export function* appSaga() {
  yield all([
    takeLatest(appActions.loadApp, loadAppWorker),
    takeLatest(appActions.installApp, installAppWorker),
  ]);
}
